// frontend/src/data/seoMeta.js
//
// Per-route <head> copy. To change a page's title or description, edit
// seo-meta.json — no page component needs touching.
//
// WHY THE DATA IS JSON
// -------------------
// This file and scripts/prerender.js (plain Node, no bundler) must read the same
// route table. An earlier attempt made this module CommonJS so Node could
// require() it; webpack still treated it as an ES module, so the module.exports
// assignment threw at load and blanked the entire site — the head was correct
// but nothing ever rendered.
//
// JSON has no such ambiguity: webpack and Node both parse it natively, with no
// module-format interpretation to disagree about. This file stays a normal ES
// module for React; prerender.js reads the same .json directly.
//
// Guidelines when adding entries to seo-meta.json:
//   title       ~60 chars max (the brand suffix is appended automatically)
//   description ~155 chars max, written as ad copy rather than a summary
// Put the page's primary keyword at the FRONT of the title.

import data from './seo-meta.json'

export const SITE_URL   = data.SITE_URL
export const BRAND      = data.BRAND
export const DEFAULT_OG = data.DEFAULT_OG
export const seoMeta    = data.routes

/**
 * Resolve metadata for a pathname. Falls back to the homepage entry so a route
 * without its own entry still gets a valid title rather than an empty <head>.
 */
export function getSeoMeta (pathname) {
  const clean = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname

  if (seoMeta[clean]) return { ...seoMeta[clean], path: clean }

  // Dynamic segments, e.g. /reset-password/:token
  const base = `/${clean.split('/')[1] || ''}`
  if (seoMeta[base]) return { ...seoMeta[base], path: clean }

  return { ...seoMeta['/'], path: clean, jsonLd: undefined }
}
